import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import SinPermisos from "./../components/sinpermisos";
import Nav from "react-bootstrap/Nav";
import "./Mislanding.css";

const url = "https://api.mrcirp.com/public/usuarios";
const urlCampanasAudiencia = "https://api.mrcirp.com/public/campanas-audiencia";
const urldelete = "https://api.mrcirp.com/public/usuariosdelete";
const urldeleteCampanasAudiencia = "https://api.mrcirp.com/public/campanas-audiencia";
const urleditar = "https://api.mrcirp.com/public/usuariosedit";

const Mislanding = () => {
  const navigate = useNavigate();
  
  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
      
      // Cargar datos completos del usuario desde el endpoint para obtener codigo_membresia y membresia
      if (user.id) {
        axios.get(`https://api.mrcirp.com/public/userpanel/${user.id}`)
          .then((response) => {
            if (response.data && response.data[0]) {
              const userData = response.data[0];
              // Actualizar el estado con los datos completos incluyendo membresía
              setUsers(prevUser => ({
                ...prevUser,
                ...userData
              }));
            }
          })
          .catch((error) => {
            console.error('Error cargando datos del usuario:', error);
          });
      }
    }
  }, []);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    id: "",
    usuario: "",
    descripcion: "",
    urlvideo: "",
    urlvideoproducto1: "",
    urlvideoproducto2: "",
    urlvideoproducto3: "",
    urlnegocio1: "",
    urlnegocio2: "",
    urlnegocio3: "",
    urlcomounirsecliente: "",
    urlcomoafiliarse: "",
    fecha: "",
    urlBotonProducto: "",
    urlBotonNegocio: "",
  });

  /////////////////Datatable/////////////////////////////////

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  const [pending, setPending] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setData(data);
      setPending(false);
    }, 100);
    return () => clearTimeout(timeout);
  });

  const columns = [
    {
      name: "Accion",
      button: true,
      width: "200px",
      cell: (row) => (
        <div className="modern-action-buttons">
          <button
            onClick={() => {
              if (row.tipo === 'video') {
                window.open(`https://katanasite.app/${row.usuario}`, "_blank");
              } else {
                // Para campañas de lanzamiento, abrir en nueva pestaña
                window.open(`https://katanasite.app/audiencia/${row.usuario}`, "_blank");
              }
            }}
            className="modern-action-btn view"
            title="Ver landing"
          >
            <FaIcons.FaEye />
          </button>
          <button
            onClick={() => {
              if (row.tipo === 'audiencia') {
                // Para campañas de audiencia, navegar a la página de edición
                navigate(`/editar-campana-audiencia/${row.id}`);
              } else {
                // Para campañas de video, navegar a la página de edición
                navigate(`/editar-campana-video/${row.id}`);
              }
            }}
            className="modern-action-btn edit"
            title="Editar campaña"
          >
            <FaIcons.FaRegEdit />
          </button>
          {/* Botón bloquear oculto por ahora
          <button
            onClick={() => {
              abrirModalContrasena(row);
            }}
            className="modern-action-btn lock"
            title="Establecer contraseña"
          >
            <FaIcons.FaLock />
          </button>
          */}
          <button
            className="modern-action-btn delete"
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalEditar();
            }}
            title="Eliminar campaña"
          >
            <FaIcons.FaTrash />
          </button>
        </div>
      ),
    },
    {
      name: "Id",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: "Estado",
      width: "120px",
      cell: (row) => {
        const isActive = row.activa === 1 || row.activa === true;
        return (
          <div 
            onClick={(e) => {
              e.stopPropagation();
              toggleCampanaActiva(row);
            }}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              cursor: 'pointer',
              gap: '8px',
              userSelect: 'none'
            }}
          >
            <div style={{
              position: 'relative',
              width: '50px',
              height: '26px',
              backgroundColor: isActive ? '#52c41a' : '#d9d9d9',
              borderRadius: '26px',
              transition: 'background-color 0.3s ease',
              cursor: 'pointer',
              flexShrink: 0
            }}>
              <div style={{
                position: 'absolute',
                top: '3px',
                left: isActive ? '27px' : '3px',
                width: '20px',
                height: '20px',
                backgroundColor: 'white',
                borderRadius: '50%',
                transition: 'left 0.3s ease',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }} />
            </div>
            <span style={{
              fontSize: '12px',
              fontWeight: '600',
              color: isActive ? '#52c41a' : '#999',
              userSelect: 'none',
              minWidth: '35px'
            }}>
              {isActive ? 'ON' : 'OFF'}
            </span>
          </div>
        );
      },
    },
    {
      name: "Tipo",
      selector: (row) => row.tipo,
      cell: (row) => (
        <span style={{
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: 'bold',
          color: 'white',
          backgroundColor: row.tipo === 'video' ? '#52c41a' : '#1890ff'
        }}>
          {row.tipo === 'video' ? '🎬 Video' : '🚀 Lanzamiento'}
        </span>
      ),
    },
    {
      name: "Nombre de Campaña",
      selector: (row) => row.nombrecampana,
    },
    {
      name: "Enlace",
      selector: (row) => row.usuario,
    },
    {
      name: "Descripcion",
      selector: (row) => row.descripcion,
    },
  ];
  /////////////Buscar datos//////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line
    const result = data.filter((resultdata) => {
      if (
        resultdata.usuario.toLowerCase().match(buscar.toLowerCase()) ||
        resultdata.descripcion.toLowerCase().match(buscar.toLowerCase()) ||
        (resultdata.nombrecampana && resultdata.nombrecampana.toLowerCase().match(buscar.toLowerCase()))
      ) {
        return resultdata;
      }
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  ///////////////Insertar Datos//////////////////////////////////

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatosSeleccionados((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [Error, setError] = useState(false);

  /*   const peticionPost = async () => {
    delete datosSeleccionados.id;
    console.log(datosSeleccionados);
    await axios.post(url, datosSeleccionados).then(res => {
      peticionGet();
      setError(false);
     
    })
      .catch((err) => {
        setError(true);
        
      })
  }
 */
  //////////////Editar datos/////////////////////////////////////
  const [modalEditar, setModalEditar] = useState(false);
  const abrirModalEditar = () => {
    setModalEditar(true);
  };

  const peticionPut = async () => {
    try {
      let deleteUrl;
      
      // Determinar la URL de eliminación según el tipo de campaña
      if (datosSeleccionados.tipo === 'audiencia') {
        deleteUrl = urldeleteCampanasAudiencia + "/" + datosSeleccionados.id;
      } else {
        deleteUrl = urldelete + "/" + datosSeleccionados.id;
      }
      
      await axios.delete(deleteUrl, datosSeleccionados)
        .then((response) => {
          peticionGet();
          setError(false);
          setModalEditar(false);
        })
        .catch((err) => {
          console.error('Error al eliminar:', err);
          setError(true);
          setModalEditar(false);
        });
    } catch (error) {
      console.error('Error al eliminar campaña:', error);
      setError(true);
      setModalEditar(false);
    }
  };

  const [modalEditaruser, setModalEditaruser] = useState(false);
  const abrirModalEditaruser = () => {
    setModalEditaruser(true);
  };

  //////////////Estados para Modal de Contraseña/////////////////////////
  const [modalContrasena, setModalContrasena] = useState(false);
  const [contrasenaData, setContrasenaData] = useState({
    id: "",
    contrasena: "",
    confirmarContrasena: ""
  });
  const [mostrarContrasena, setMostrarContrasena] = useState(false);
  const [mostrarConfirmar, setMostrarConfirmar] = useState(false);

  const abrirModalContrasena = (row) => {
    setContrasenaData({
      id: row.id,
      contrasena: "",
      confirmarContrasena: ""
    });
    setMostrarContrasena(false);
    setMostrarConfirmar(false);
    setModalContrasena(true);
  };

  const handleContrasenaChange = (e) => {
    const { name, value } = e.target;
    setContrasenaData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const guardarContrasena = async () => {
    if (!contrasenaData.contrasena || !contrasenaData.confirmarContrasena) {
      alert('Por favor completa todos los campos');
      return;
    }

    if (contrasenaData.contrasena !== contrasenaData.confirmarContrasena) {
      alert('Las contraseñas no coinciden');
      return;
    }

    if (contrasenaData.contrasena.length < 6) {
      alert('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    try {
      // Simulamos el guardado de la contraseña
      // En producción, aquí harías la llamada a la API
      console.log('Guardando contraseña para landing:', contrasenaData.id);
      console.log('Contraseña:', contrasenaData.contrasena);
      
      alert('Contraseña establecida exitosamente');
      setModalContrasena(false);
      setContrasenaData({
        id: "",
        contrasena: "",
        confirmarContrasena: ""
      });
      setMostrarContrasena(false);
      setMostrarConfirmar(false);
    } catch (error) {
      console.error('Error al guardar contraseña:', error);
      alert('Error al guardar la contraseña');
    }
  };

  // Función para cambiar el estado activo/inactivo de una campaña
  const toggleCampanaActiva = async (row) => {
    const estadoAnterior = row.activa === 1 || row.activa === true ? 1 : 0;
    const nuevoEstado = estadoAnterior === 1 ? 0 : 1;
    
    // Actualizar el estado local INMEDIATAMENTE (optimistic update)
    setData(prevData => 
      prevData.map(campana => 
        campana.id === row.id && campana.tipo === row.tipo
          ? { ...campana, activa: nuevoEstado }
          : campana
      )
    );
    
    setFiltroBuscar(prevData => 
      prevData.map(campana => 
        campana.id === row.id && campana.tipo === row.tipo
          ? { ...campana, activa: nuevoEstado }
          : campana
      )
    );
    
    try {
      // Luego hacer la llamada a la API
      let response;
      if (row.tipo === 'audiencia') {
        // Actualizar campaña de audiencia
        response = await axios.put(`https://api.mrcirp.com/public/campanas-audiencia/${row.id}`, {
          activa: nuevoEstado
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      } else {
        // Actualizar campaña de video
        response = await axios.put(`https://api.mrcirp.com/public/usuariosedit/${row.id}`, {
          activa: nuevoEstado
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      }
      
      console.log('Estado actualizado correctamente:', response.data);
      
    } catch (error) {
      console.error('Error al actualizar estado de la campaña:', error);
      console.error('Detalles del error:', error.response?.data || error.message);
      
      // Revertir el cambio si hay error
      setData(prevData => 
        prevData.map(campana => 
          campana.id === row.id && campana.tipo === row.tipo
            ? { ...campana, activa: estadoAnterior }
            : campana
        )
      );
      
      setFiltroBuscar(prevData => 
        prevData.map(campana => 
          campana.id === row.id && campana.tipo === row.tipo
            ? { ...campana, activa: estadoAnterior }
            : campana
        )
      );
      
      alert(`Error al actualizar el estado de la campaña: ${error.response?.data?.message || error.message || 'Error desconocido'}`);
    }
  };

  const peticionPutuser = async () => {
    console.log(datosSeleccionados);
    await axios
      .put(urleditar + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        peticionGet();
        setError(false);
        setModalEditaruser(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalEditaruser(false);
      });
  };

  /////////////Mostrar datos//////////////////////////////////
  const peticionGet = async () => {
    console.log(users);
    try {
      // Obtener campañas de video (usuarios)
      const responseVideo = await axios.get(url);
      const filteredVideoData = responseVideo.data.filter(item => item.creador === users.id);
      
      // Obtener campañas de lanzamiento
      const responseAudiencia = await axios.get(urlCampanasAudiencia);
      const filteredAudienciaData = responseAudiencia.data.filter(item => item.admin_id === users.id);
      
      // Combinar ambas campañas y agregar tipo
      const videoCampaigns = filteredVideoData.map(item => ({
        ...item,
        tipo: 'video',
        nombre_campana: item.nombrecampana || 'Sin nombre',
        enlace_campana: item.usuario,
        fecha_creacion: item.fecha,
        activa: item.activa !== undefined ? item.activa : 1 // Por defecto activa si no existe
      }));
      
      const audienciaCampaigns = filteredAudienciaData.map(item => ({
        ...item,
        tipo: 'audiencia',
        usuario: item.enlace_campana,
        nombrecampana: item.nombre_campana,
        fecha: item.fecha_creacion,
        activa: item.activa !== undefined ? item.activa : 1 // Por defecto activa si no existe
      }));
      
      // Combinar todas las campañas
      const allCampaigns = [...videoCampaigns, ...audienciaCampaigns];
      
      setData(allCampaigns);
      setFiltroBuscar(allCampaigns);
    } catch (error) {
      console.error('Error al obtener campañas:', error);
      setData([]);
      setFiltroBuscar([]);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (users.id) {
      await peticionGet();
    }
  }, [users.id]);

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "cliente") {
      return (
        <Sidebar>
        <div className="container">
         
            <Card className="modern-card">
              <Card.Header className="modern-card-header" as="h3">
                <div className="row">
                  <div className="col-md-12">🎯 Campañas Registradas</div>
                </div>
              </Card.Header>
              <Card.Body className="modern-card-body">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <h2 className="modern-title" style={{ marginBottom: 0 }}>Mis Campañas</h2>
                  {users.codigo_membresia && users.membresia && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                      <span style={{ 
                        fontSize: '1rem', 
                        fontWeight: '600', 
                        color: '#2d3748',
                        padding: '4px 12px',
                        backgroundColor: '#f7fafc',
                        borderRadius: '8px',
                        border: '1px solid #e2e8f0'
                      }}>
                        {users.codigo_membresia}
                      </span>
                      <span style={{ 
                        fontSize: '1rem', 
                        fontWeight: '600', 
                        color: '#2d3748',
                        padding: '4px 12px',
                        backgroundColor: '#f7fafc',
                        borderRadius: '8px',
                        border: '1px solid #e2e8f0'
                      }}>
                        {(() => {
                          const limites = {
                            'Katana Demo': 1,
                            'Katana Basic': 2,
                            'Katana Pro': 5,
                            'Katana Premium': 10
                          };
                          const limite = limites[users.membresia] || 0;
                          // Contar solo las campañas activas
                          const actual = data.filter(campana => {
                            return campana.activa === 1 || campana.activa === true;
                          }).length;
                          const restantes = limite - actual;
                          return `${actual}/${limite}`;
                        })()}
                      </span>
                    </div>
                  )}
                </div>
                {Error && (
                  <div className="modern-alert modern-alert-danger">
                    <strong>Error: El nombre ya existe! Intente con otro nombre.</strong>
                  </div>
                )}
                <p className="modern-subtitle">Gestiona todas tus campañas de landing page desde aquí.</p>
                <div className="modern-search-container">
                  <div className="position-relative">
                    <FaIcons.FaSearch className="modern-search-icon" />
                    <input
                      type="text"
                      placeholder="Buscar por nombre de campaña o enlace..."
                      className="modern-search-input"
                      value={buscar}
                      onChange={(e) => setBuscar(e.target.value)}
                    />
                  </div>
                </div>
                <div className="mislanding-table-wrapper">
                <DataTable
                  columns={columns}
                  data={filtrobuscar}
                  responsive={false}
                  noDataComponent={
                    <div style={{ padding: '40px', textAlign: 'center', color: '#718096' }}>
                      <FaIcons.FaSearch style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }} />
                      <p>No se encontraron campañas</p>
                    </div>
                  }
                  progressPending={pending}
                  progressComponent={<Cargando />}
                  pagination
                  paginationComponentOptions={paginationComponentOptions}
                  className="modern-datatable"
                  customStyles={{
                    table: {
                      style: {
                        borderRadius: '12px',
                        overflow: 'hidden'
                      }
                    }
                  }}
                />
                </div>

                  <Modal isOpen={modalEditar} className="modern-modal">
                    <ModalHeader className="modern-modal-header">
                      <div>
                        <h4 className="modern-modal-title">🗑️ Eliminar Campaña</h4>
                      </div>
                    </ModalHeader>
                    <ModalBody className="modern-modal-body">
                      <input
                        className="modern-form-control"
                        readOnly
                        type="hidden"
                        name="id"
                        value={datosSeleccionados.id}
                        onChange={onchange}
                      />
                      <div className="modern-form-group">
                        <div className="modern-alert modern-alert-warning">
                          <strong>⚠️ Advertencia:</strong> Esta acción no se puede deshacer.
                        </div>
                        <h5 style={{ color: '#2d3748', marginBottom: '16px' }}>
                          ¿Está seguro de que desea eliminar la campaña <strong>#{datosSeleccionados.id}</strong>?
                        </h5>
                        <p style={{ color: '#718096', margin: 0 }}>
                          Se eliminará permanentemente: <strong>{datosSeleccionados.nombrecampana}</strong>
                        </p>
                      </div>
                    </ModalBody>
                    <ModalFooter className="modern-modal-footer">
                      <button
                        className="modern-btn modern-btn-secondary"
                        onClick={() => setModalEditar(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="modern-btn modern-btn-danger"
                        onClick={() => peticionPut()}
                      >
                        <FaIcons.FaTrash /> Eliminar
                      </button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={modalEditaruser} className="modern-modal">
                    <ModalHeader className="modern-modal-header">
                      <div>
                        <h5 className="modern-modal-title">✏️ Editar Campaña</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody className="modern-modal-body">
                      <div className="modern-form-group">
                        <input
                          className="modern-form-control"
                          readOnly
                          type="hidden"
                          name="id"
                          value={datosSeleccionados.id}
                          onChange={handleChange}
                        />

                        <label className="modern-form-label">Descripción de la campaña</label>
                        <textarea
                          className="modern-form-control"
                          name="descripcion"
                          value={datosSeleccionados.descripcion}
                          onChange={handleChange}
                          rows="3"
                          placeholder="Describe tu campaña..."
                        />
                       
                        <label className="modern-form-label">URL del video principal</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideo"
                          value={datosSeleccionados.urlvideo}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                      
                        <label className="modern-form-label">URL Zona de revelación 1</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideoproducto1"
                          value={datosSeleccionados.urlvideoproducto1}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                      
                        <label className="modern-form-label">URL Zona de revelación 2</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideoproducto2"
                          value={datosSeleccionados.urlvideoproducto2}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                       
                        <label className="modern-form-label">URL Zona de revelación 3</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideoproducto3"
                          value={datosSeleccionados.urlvideoproducto3}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                       
                        <label className="modern-form-label">URL como unirse como cliente</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlcomounirsecliente"
                          value={datosSeleccionados.urlcomounirsecliente}
                          onChange={handleChange}
                          placeholder="https://ejemplo.com/unirse"
                        />
                      
                        <label className="modern-form-label">URL Botón Zona de revelación</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlBotonProducto"
                          value={datosSeleccionados.urlBotonProducto}
                          onChange={handleChange}
                          placeholder="https://ejemplo.com/boton"
                        />
                        
                        <label className="modern-form-label">URL zona de éxito 1</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlnegocio1"
                          value={datosSeleccionados.urlnegocio1}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                        
                        <label className="modern-form-label">URL zona de éxito 2</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlnegocio2"
                          value={datosSeleccionados.urlnegocio2}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                       
                        <label className="modern-form-label">URL zona de éxito 3</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlnegocio3"
                          value={datosSeleccionados.urlnegocio3}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                    
                        <label className="modern-form-label">URL como afiliarse</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlcomoafiliarse"
                          value={datosSeleccionados.urlcomoafiliarse}
                          onChange={handleChange}
                          placeholder="https://ejemplo.com/afiliarse"
                        />
                         
                        <label className="modern-form-label">URL botón zona de éxito</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlBotonNegocio"
                          value={datosSeleccionados.urlBotonNegocio}
                          onChange={handleChange}
                          placeholder="https://ejemplo.com/boton-exito"
                        />
                        
                      </div>
                    </ModalBody>
                    <ModalFooter className="modern-modal-footer">
                      <button
                        className="modern-btn modern-btn-secondary"
                        onClick={() => setModalEditaruser(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="modern-btn modern-btn-primary"
                        onClick={() => peticionPutuser()}
                      >
                        <FaIcons.FaSave /> Actualizar
                      </button>
                    </ModalFooter>
                  </Modal>

                  {/* Modal para establecer contraseña */}
                  <Modal isOpen={modalContrasena} className="modern-modal">
                    <ModalHeader className="modern-modal-header">
                      <div>
                        <h5 className="modern-modal-title">🔒 Establecer Contraseña para Landing</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody className="modern-modal-body">
                      <div className="modern-form-group">
                        <input
                          className="modern-form-control"
                          readOnly
                          type="hidden"
                          name="id"
                          value={contrasenaData.id}
                        />
                        
                        <div className="modern-alert modern-alert-info">
                          <strong>ID de la Campaña:</strong> #{contrasenaData.id}
                        </div>

                        <label className="modern-form-label"><strong>Nueva Contraseña *</strong></label>
                        <div className="modern-input-group">
                          <input
                            className="modern-form-control"
                            type={mostrarContrasena ? "text" : "password"}
                            name="contrasena"
                            value={contrasenaData.contrasena}
                            onChange={handleContrasenaChange}
                            placeholder="Ingresa la nueva contraseña"
                            minLength="6"
                          />
                          <button
                            className="modern-btn"
                            type="button"
                            onClick={() => setMostrarContrasena(!mostrarContrasena)}
                            title={mostrarContrasena ? "Ocultar contraseña" : "Mostrar contraseña"}
                          >
                            {mostrarContrasena ? <FaIcons.FaEyeSlash /> : <FaIcons.FaEye />}
                          </button>
                        </div>
                        <small style={{ color: '#718096', fontSize: '0.75rem' }}>
                          Mínimo 6 caracteres
                        </small>

                        <label className="modern-form-label"><strong>Confirmar Contraseña *</strong></label>
                        <div className="modern-input-group">
                          <input
                            className="modern-form-control"
                            type={mostrarConfirmar ? "text" : "password"}
                            name="confirmarContrasena"
                            value={contrasenaData.confirmarContrasena}
                            onChange={handleContrasenaChange}
                            placeholder="Confirma la contraseña"
                            minLength="6"
                          />
                          <button
                            className="modern-btn"
                            type="button"
                            onClick={() => setMostrarConfirmar(!mostrarConfirmar)}
                            title={mostrarConfirmar ? "Ocultar contraseña" : "Mostrar contraseña"}
                          >
                            {mostrarConfirmar ? <FaIcons.FaEyeSlash /> : <FaIcons.FaEye />}
                          </button>
                        </div>

                        <div className="modern-alert modern-alert-warning">
                          <strong>⚠️ Importante:</strong> Una vez establecida la contraseña, 
                          los usuarios necesitarán ingresarla para acceder a esta landing.
                        </div>
                      </div>
                    </ModalBody>
                    <ModalFooter className="modern-modal-footer">
                      <button
                        className="modern-btn modern-btn-secondary"
                        onClick={() => setModalContrasena(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="modern-btn modern-btn-primary"
                        onClick={guardarContrasena}
                      >
                        <FaIcons.FaLock /> Establecer Contraseña
                      </button>
                    </ModalFooter>
                </Modal>
              </Card.Body>
            </Card>
        
        </div>
        </Sidebar>
      );
    } else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  } else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Mislanding;